import { getWorkspaceSlugFromHostname } from "./workspace-validation";

const ANO_HOSTNAME_PATTERN = /(?:^|\.)ano\.dev$/;
const LOCALHOST_PATTERN = /(?:^|\.)localhost$/;

function isAllowedReturnHost(hostname: string): boolean {
  return (
    ANO_HOSTNAME_PATTERN.test(hostname) || LOCALHOST_PATTERN.test(hostname)
  );
}

export function normalizePostAuthReturnPath(
  returnTo: string | null | undefined,
  currentOrigin: string,
): string | null {
  if (typeof returnTo !== "string") return null;

  try {
    const url = new URL(returnTo);
    const current = new URL(currentOrigin);
    if (
      url.origin !== current.origin &&
      !isAllowedReturnHost(url.hostname.toLowerCase())
    ) {
      return null;
    }

    const legacySlug =
      url.origin === current.origin
        ? null
        : getWorkspaceSlugFromHostname(url.hostname.toLowerCase());
    const slugPathPrefix = legacySlug ? `/${legacySlug}` : null;
    const legacyPath =
      legacySlug && legacySlug !== "home"
        ? url.pathname === "/"
          ? `/${legacySlug}`
          : url.pathname === slugPathPrefix ||
              url.pathname.startsWith(`${slugPathPrefix}/`)
            ? url.pathname
            : `/${legacySlug}${url.pathname}`
        : url.pathname;
    const path = `${legacyPath}${url.search}${url.hash}`;
    return path || "/";
  } catch {
    return null;
  }
}
